import React, { useState } from 'react';
import { useSwiper } from 'swiper/react';
import { CarouselIconButton } from './buttons/CarouselIconButton';
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';

export const SwiperNavButtons = ({
  currentSlide,
  maxSlides,
}: {
  currentSlide: number;
  maxSlides: number;
}) => {
  const swiper = useSwiper();

  return (
    <div
      className="swiper-nav-btns"
      // Don't trigger card link navigation
      onClick={(e) => e.stopPropagation()}
    >
      {currentSlide > 0 && (
        <CarouselIconButton
          onClick={(e) => {
            // Don't trigger card link navigation
            e.preventDefault();
            e.stopPropagation();
            swiper.slidePrev();
          }}
          size="sm"
          left="3"
          // onClick={handlePrev}
          icon={<IoChevronBackOutline />}
          aria-label="Previous Slide"
          className="prev-arrow"
        />
      )}
      {currentSlide < maxSlides - 1 && (
        <CarouselIconButton
          onClick={(e) => {
            // Don't trigger card link navigation
            e.preventDefault();
            e.stopPropagation();
            swiper.slideNext();
          }}
          size="sm"
          right="3"
          // onClick={handlePrev}
          icon={<IoChevronForwardOutline />}
          aria-label="Previous Slide"
          className="next-arrow"
        />
      )}
    </div>
  );
};
